import {apiWithToken} from "../../../systems/api";
import {API_URL} from "../../../systems/globalContant";

export default {
    resolve: (order_id, data = {}) => apiWithToken.put(API_URL.DEFAULT + `/order-problems/${order_id}/resolve`, data, {loading: false}),
    unresolve: (order_id) => apiWithToken.put(API_URL.DEFAULT + `/order-problems/${order_id}/un-resolve`, {}, {loading: false})
};
